import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const PLATFORMS = [
  { code: 'SMARTSTORE', name: 'S' },
  { code: 'ELEVENST', name: '11st' },
  { code: 'GMARKET', name: 'G' },
  { code: 'AUCTION', name: 'A' },
  { code: 'COUPANG', name: 'C' },
  { code: 'SELLERHUB', name: 'Hub' },
  { code: 'TOSS', name: 'T' },
];

function CatalogSelector({ endpoint, textValue, catalogId, catalogName, onChangeText, onSelectCatalog, placeholder }) {
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async () => {
    if (!textValue.trim()) return;
    setSearching(true);
    setSearched(true);
    try {
      const r = await api.get(endpoint, { params: { name: textValue.trim() } });
      setResults(r.data || []);
    } catch (err) { console.error(err); setResults([]); }
    finally { setSearching(false); }
  };

  const handleSelect = (item) => {
    setResults([]);
    setSearched(false);
    onSelectCatalog(item.id, item.name);
  };

  const handleClearMatch = () => {
    onSelectCatalog(null, textValue);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <input
          value={textValue}
          onChange={e => { onChangeText(e.target.value); setResults([]); setSearched(false); }}
          placeholder={placeholder}
          style={{ fontSize: '12px', padding: '6px 10px', borderRadius: '6px', border: '0.5px solid ' + (catalogId ? '#1D9E75' : '#ddd'), flex: 1, boxSizing: 'border-box', background: catalogId ? '#E1F5EE' : '#fff' }} />
        <button onClick={handleSearch} disabled={searching || !textValue.trim()} style={{ flexShrink: 0, fontSize: '11px', padding: '6px 10px', borderRadius: '6px', border: '0.5px solid #ddd', background: '#fafafa', color: '#555', cursor: searching ? 'not-allowed' : 'pointer' }}>
          {searching ? '검색 중' : '검색'}
        </button>
        {catalogId && (
          <button onClick={handleClearMatch} title="카탈로그 매칭 해제" style={{ flexShrink: 0, fontSize: '11px', color: '#e53935', border: 'none', background: 'none', cursor: 'pointer' }}>✕</button>
        )}
      </div>
      {catalogId && <div style={{ fontSize: '11px', color: '#1D9E75', marginTop: '3px' }}>카탈로그 매칭됨</div>}
      {searched && !searching && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '0.5px solid #ddd', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {results.length === 0 ? (
            <div style={{ padding: '10px 14px', fontSize: '12px', color: '#aaa' }}>검색 결과 없음. 입력하신 텍스트가 그대로 사용됩니다.</div>
          ) : (
            results.map(item => (
              <div key={item.id} onClick={() => handleSelect(item)}
                style={{ padding: '8px 14px', fontSize: '12px', cursor: 'pointer', borderBottom: '0.5px solid #f0f0f0' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f5f5'}
                onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                {item.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
function BrandSelector({ textValue, catalogId, onChangeText, onSelectCatalog }) {
  return <CatalogSelector endpoint="/product-settings/naver/brands/search" textValue={textValue} catalogId={catalogId} onChangeText={onChangeText} onSelectCatalog={onSelectCatalog} placeholder="브랜드명 입력" />;
}
function ManufacturerSelector({ textValue, catalogId, onChangeText, onSelectCatalog }) {
  return <CatalogSelector endpoint="/product-settings/naver/manufacturers/search" textValue={textValue} catalogId={catalogId} onChangeText={onChangeText} onSelectCatalog={onSelectCatalog} placeholder="제조사명 입력" />;
}

function CategorySelector({ value, onChange, currentCategory }) {
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(currentCategory || null);
  const [searching, setSearching] = useState(false);

  const handleSearch = async (kw) => {
    setKeyword(kw);
    if (!kw.trim()) { setResults([]); return; }
    setSearching(true);
    try {
      const r = await api.get('/categories/search', { params: { keyword: kw } });
      setResults(r.data);
    } catch (err) { console.error(err); }
    finally { setSearching(false); }
  };

  const handleSelect = (cat) => {
    const label = [cat.large_category, cat.middle_category, cat.small_category, cat.detail_category].filter(Boolean).join(' > ');
    setSelected({ id: cat.id, label });
    setKeyword('');
    setResults([]);
    onChange(cat.id);
  };

  const handleClear = () => { setSelected(null); setKeyword(''); setResults([]); onChange(null); };

  return (
    <div style={{ position: 'relative' }}>
      {selected ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', background: '#E1F5EE', border: '0.5px solid #1D9E75', borderRadius: '6px' }}>
          <span style={{ fontSize: '12px', color: '#085041', flex: 1 }}>{selected.label}</span>
          <button onClick={handleClear} style={{ fontSize: '11px', color: '#e53935', border: 'none', background: 'none', cursor: 'pointer' }}>✕</button>
        </div>
      ) : (
        <>
          <input value={keyword} onChange={e => handleSearch(e.target.value)} placeholder="카테고리 키워드 검색"
            style={{ fontSize: '12px', padding: '6px 10px', borderRadius: '6px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
          {(results.length > 0 || searching) && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '0.5px solid #ddd', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
              {searching && <div style={{ padding: '10px 14px', fontSize: '12px', color: '#aaa' }}>검색 중...</div>}
              {results.map(cat => {
                const label = [cat.large_category, cat.middle_category, cat.small_category, cat.detail_category].filter(Boolean).join(' > ');
                return (
                  <div key={cat.id} onClick={() => handleSelect(cat)}
                    style={{ padding: '8px 14px', fontSize: '12px', cursor: 'pointer', borderBottom: '0.5px solid #f0f0f0' }}
                    onMouseEnter={e=>e.currentTarget.style.background='#f5f5f5'}
                    onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                    {label}
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}



function DetailPageEditor({ value, onChange }) {
  const editorRef = useRef(null);
  const selectedImgRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [fontSize, setFontSize] = useState('16');

  useEffect(() => {
    if (editorRef.current && editorRef.current.innerHTML !== (value || '')) {
      editorRef.current.innerHTML = value || '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emitChange = () => {
    if (editorRef.current) onChange(editorRef.current.innerHTML);
  };

  const exec = (cmd, arg) => {
    editorRef.current.focus();
    document.execCommand(cmd, false, arg);
    emitChange();
  };
  const alignSelectedImage = (align) => {
    editorRef.current.focus();
    const img = selectedImgRef.current;
    if (img && img.tagName === 'IMG' && editorRef.current.contains(img)) {
      img.style.display = 'block';
      if (align === 'left') { img.style.margin = '8px auto 8px 0'; }
      else if (align === 'center') { img.style.margin = '8px auto'; }
      else if (align === 'right') { img.style.margin = '8px 0 8px auto'; }
      emitChange();
    } else {
      const cmd = align === 'left' ? 'justifyLeft' : align === 'center' ? 'justifyCenter' : 'justifyRight';
      document.execCommand(cmd, false, null);
      emitChange();
    }
  };
  const handleEditorClick = (e) => {
    selectedImgRef.current = e.target.tagName === 'IMG' ? e.target : null;
  };

  const applyFontSize = (size) => {
    setFontSize(size);
    editorRef.current.focus();
    document.execCommand('fontSize', false, '7');
    const fontElements = editorRef.current.querySelectorAll('font[size="7"]');
    fontElements.forEach(el => {
      el.removeAttribute('size');
      el.style.fontSize = size + 'px';
    });
    emitChange();
  };

  const insertImages = async (files) => {
    if (!files || files.length === 0) return;
    setUploading(true);
    try {
      const fd = new FormData();
      Array.from(files).forEach(f => fd.append('images', f));
      const r = await api.post('/products/detail-images/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      editorRef.current.focus();
      (r.data.images || []).forEach(img => {
        document.execCommand('insertHTML', false, `<img src="https://admin.jinhalife.co.kr${img.url}" style="max-width:100%;display:block;margin:8px auto;" />`);
      });
      emitChange();
    } catch (err) { alert('이미지 업로드 실패'); }
    finally { setUploading(false); }
  };

  const btnStyle = { fontSize: '12px', padding: '5px 9px', borderRadius: '6px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer', color: '#444' };

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', padding: '6px', background: '#f5f5f5', borderRadius: '8px 8px 0 0', border: '0.5px solid #ddd', borderBottom: 'none' }}>
        <button type="button" onClick={() => exec('bold')} style={{ ...btnStyle, fontWeight: '700' }}>B</button>
        <button type="button" onClick={() => exec('italic')} style={{ ...btnStyle, fontStyle: 'italic' }}>I</button>
        <button type="button" onClick={() => exec('underline')} style={{ ...btnStyle, textDecoration: 'underline' }}>U</button>
        <select value={fontSize} onChange={e => applyFontSize(e.target.value)} style={{ fontSize: '12px', padding: '5px 6px', borderRadius: '6px', border: '0.5px solid #ddd', background: '#fff' }}>
          {['12','14','16','18','20','24','28'].map(s => <option key={s} value={s}>{s}px</option>)}
        </select>
        <button type="button" onClick={() => alignSelectedImage('left')} style={btnStyle}>◀</button>
        <button type="button" onClick={() => alignSelectedImage('center')} style={btnStyle}>■</button>
        <button type="button" onClick={() => alignSelectedImage('right')} style={btnStyle}>▶</button>
        <label style={{ ...btnStyle, cursor: uploading ? 'not-allowed' : 'pointer', color: uploading ? '#aaa' : '#185FA5' }}>
          {uploading ? '업로드 중...' : '이미지 삽입'}
          <input type="file" accept="image/*" multiple disabled={uploading} onChange={e => { insertImages(e.target.files); e.target.value = ''; }} style={{ display: 'none' }} />
        </label>
      </div>
      <div
        ref={editorRef}
        contentEditable
        onInput={emitChange}
        onBlur={emitChange}
        onClick={handleEditorClick}
        style={{ minHeight: '220px', padding: '12px', border: '0.5px solid #ddd', borderRadius: '0 0 8px 8px', fontSize: '13px', lineHeight: '1.6', color: '#1a1a1a', background: '#fff' }}
      />
      <div style={{ fontSize: '10px', color: '#aaa', marginTop: '4px' }}>전송 시 여기 들어간 이미지 전체와 아래 설정된 공통 하단 이미지가 함께 전송됩니다.</div>
    </div>
  );
}

function ProductForm({ product, onSave, onCancel, titleOverride }) {
  const [form, setForm] = useState({
    product_code: product?.product_code || '',
    name: product?.name || '',
    category_id: product?.category_id || '',
    expected_price: product?.expected_price || '',
    stock: product?.stock || '',
    brand: product?.brand || '',
    brand_id: product?.brand_id || null,
    manufacturer: product?.manufacturer || '',
    manufacturer_id: product?.manufacturer_id || null,
    origin: product?.origin || '국산',
    tax_type: product?.tax_type || '과세',
    total_capacity_value: product?.total_capacity_value || '',
    unit_capacity_value: product?.unit_capacity_value || '',
    unit_capacity_type: product?.unit_capacity_type || '',
    storage_method: product?.storage_method || '',
    chemical_certification_exempt: product?.chemical_certification_exempt !== false,
    tags: product?.tags || '',
    purchase_url: product?.purchase_url || '',
    price_compare_url: product?.price_compare_url || '',
    description: product?.description || '',
    delivery_fee_type: product?.delivery_fee_type || 'FREE',
    is_today_delivery: product?.is_today_delivery || false,
    today_delivery_deadline: product?.today_delivery_deadline || '',
    delivery_base_fee: product?.delivery_base_fee ?? 0,
    delivery_free_conditional_amount: product?.delivery_free_conditional_amount ?? 0,
    dispatch_days: product?.dispatch_days ? String(product.dispatch_days) : '', // 발송예정일: ''=기본(2일), '3', '4'
    product_group_id: product?.product_group_id ? String(product.product_group_id) : '', // 상품그룹: ''=미분류
  });
  // [기능 추가 - 2026-10-23] 상품그룹 드롭다운용 목록 (설정 > 상품그룹 관리에서 등록)
  const [productGroups, setProductGroups] = useState([]);
  useEffect(() => { api.get('/product-settings/product-groups').then(r => setProductGroups(r.data || [])).catch(() => {}); }, []);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(product?.thumbnail ? `https://admin.jinhalife.co.kr${product.thumbnail}` : null);
  // [버그 수정 - 2026-09-04] 판매처별 실판매가 미리보기는, 프론트에 마진율 계산 로직을
  // 별도로 복제해두지 않고, 백엔드(설정 > 마진율 관리에서 관리하는 실제 값)를 그대로 조회해서
  // 보여준다. 쿠팡도 이제 마진율 관리가 생겼으니 다른 판매처와 동일하게 자동 계산한다
  // (수동 입력 칸은 제거, 필요 시 전송 단계의 오버라이드로 조정한다).
  const [calcPrices, setCalcPrices] = useState({});
  const [feeRates, setFeeRates] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!form.expected_price) return;
    const timer = setTimeout(() => {
      api.get('/products/preview-prices', { params: { expected_price: form.expected_price } }).then(r => {
        const prices = {}, fees = {};
        Object.entries(r.data || {}).forEach(([platform, v]) => { prices[platform] = v.salePrice; fees[platform] = v.feeRate; });
        setCalcPrices(prices);
        setFeeRates(fees);
      });
    }, 300);
    return () => clearTimeout(timer);
  }, [form.expected_price]);

  const handleThumbnail = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setThumbnail(file);
    setThumbnailPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!form.product_code || !form.name) { alert('자체상품코드와 상품명은 필수입니다'); return; }
    setSaving(true);
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([k, v]) => {
        formData.append(k, v);
      });
      if (thumbnail) formData.append('thumbnail', thumbnail);
      if (product?.id) {
        await api.patch(`/products/${product.id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      } else {
        await api.post('/products', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      }
      onSave();
    } catch (err) { alert('저장 실패'); }
    finally { setSaving(false); }
  };

  const inp = { fontSize: '12px', padding: '6px 8px', borderRadius: '6px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' };
  const sl = { fontSize: '11px', color: '#888', marginBottom: '3px', fontWeight: '500' };

  return (
    <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
      <div style={{ padding: '14px 18px', borderBottom: '0.5px solid #e8e8e8', background: '#fafafa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '14px', fontWeight: '600' }}>{titleOverride || (product?.id ? '상품 수정' : product ? '상품 복사 등록' : '새 상품 등록')}</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={onCancel} style={{ fontSize: '12px', padding: '6px 16px', borderRadius: '8px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer' }}>취소</button>
          <button onClick={handleSubmit} disabled={saving} style={{ fontSize: '12px', padding: '6px 16px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer' }}>
            {saving ? '저장 중...' : '저장'}
          </button>
        </div>
      </div>
      <div style={{ padding: '20px 18px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
        <div>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#444', marginBottom: '14px', paddingBottom: '6px', borderBottom: '0.5px solid #e8e8e8' }}>기본 정보</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div><div style={sl}>자체상품코드 *</div><input style={inp} value={form.product_code} onChange={e => setForm(p=>({...p, product_code: e.target.value}))} placeholder="예: PROD001" /></div>
            <div><div style={sl}>상품명 *</div><input style={inp} value={form.name} onChange={e => setForm(p=>({...p, name: e.target.value}))} placeholder="판매처에 올린 상품명" /></div>
            <div><div style={sl}>카테고리</div><CategorySelector value={form.category_id} onChange={v => setForm(p=>({...p, category_id: v||''}))} currentCategory={product?.large_category ? { id: product.category_id, label: [product.large_category, product.middle_category, product.small_category, product.detail_category].filter(Boolean).join(' > ') } : null} /></div>
            <div>
              <div style={sl}>배송비 설정</div>
              <div style={{ display: 'flex', gap: '12px', marginBottom: form.delivery_fee_type !== 'FREE' ? '8px' : 0 }}>
                {[['FREE','무료배송'],['PAID','유료배송'],['CONDITIONAL_FREE','조건부무료']].map(([val, label]) => (
                  <label key={val} style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#444', cursor: 'pointer' }}>
                    <input type="radio" name="delivery_fee_type" checked={form.delivery_fee_type === val} onChange={() => setForm(p=>({...p, delivery_fee_type: val}))} />
                    {label}
                  </label>
                ))}
              </div>
              {form.delivery_fee_type !== 'FREE' && (
                <div style={{ display: 'grid', gridTemplateColumns: form.delivery_fee_type === 'CONDITIONAL_FREE' ? '1fr 1fr' : '1fr', gap: '10px' }}>
                  <div><div style={sl}>기본 배송비</div><input type="number" style={inp} value={form.delivery_base_fee} onChange={e => setForm(p=>({...p, delivery_base_fee: e.target.value}))} placeholder="0" /></div>
                  {form.delivery_fee_type === 'CONDITIONAL_FREE' && (
                    <div><div style={sl}>무료 조건 금액</div><input type="number" style={inp} value={form.delivery_free_conditional_amount} onChange={e => setForm(p=>({...p, delivery_free_conditional_amount: e.target.value}))} placeholder="0" /></div>
                  )}
                </div>
              )}
            </div>
            {/* [기능 추가 - 2026-10-23] 상품그룹: 상품관리에서 그룹별로 묶어 보기 위한 분류 (미분류 가능) */}
            <div>
              <div style={sl}>상품그룹</div>
              <select value={form.product_group_id} onChange={e => setForm(p => ({ ...p, product_group_id: e.target.value }))}
                style={{ padding: '6px 10px', border: '0.5px solid #ccc', borderRadius: '6px', fontSize: '12px', minWidth: '240px' }}>
                <option value="">미분류</option>
                {productGroups.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
              </select>
            </div>
            {/* [기능 추가 - 2026-10-15] 상품별 발송예정일. 기본(2일)은 지금까지와 동일하고, 3일/4일을 고른 상품만 판매처별 3일/4일 설정으로 전송된다. */}
            <div>
              <div style={sl}>발송예정일 (기본 2일 · 3일/4일은 해당 상품만 변경)</div>
              <div style={{ display: 'flex', gap: '12px' }}>
                {[['', '기본 (2일)'], ['3', '3일'], ['4', '4일']].map(([val, label]) => (
                  <label key={val || 'default'} style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#444', cursor: 'pointer' }}>
                    <input type="radio" name="dispatch_days" checked={form.dispatch_days === val} onChange={() => setForm(p => ({ ...p, dispatch_days: val }))} />
                    {label}
                  </label>
                ))}
              </div>
            </div>
            <div>
              <div style={sl}>오늘출발/오늘출고 (토스쇼핑: 오늘출고, 스마트스토어: 오늘출발 - 같은 역할)</div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#444', cursor: 'pointer', marginBottom: form.is_today_delivery ? '8px' : 0 }}>
                <input type="checkbox" checked={form.is_today_delivery} onChange={e => setForm(p => ({ ...p, is_today_delivery: e.target.checked }))} />
                사용함
              </label>
              {form.is_today_delivery && (
                <>
                <div style={{ maxWidth: '200px' }}>
                  <div style={sl}>출고 마감 시각 (30분 단위)</div>
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <select style={inp} value={form.today_delivery_deadline.split(':')[0] || '14'}
                      onChange={e => setForm(p => ({ ...p, today_delivery_deadline: `${e.target.value}:${p.today_delivery_deadline.split(':')[1] || '00'}` }))}>
                      {Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0')).map(h => <option key={h} value={h}>{h}시</option>)}
                    </select>
                    <select style={inp} value={form.today_delivery_deadline.split(':')[1] || '00'}
                      onChange={e => setForm(p => ({ ...p, today_delivery_deadline: `${p.today_delivery_deadline.split(':')[0] || '14'}:${e.target.value}` }))}>
                      <option value="00">00분</option>
                      <option value="30">30분</option>
                    </select>
                  </div>
                </div>
                <div style={{ fontSize: '11px', color: '#888', lineHeight: '1.6', marginTop: '6px' }}>
                  출고 마감 시각은 토스쇼핑에만 적용됩니다. 스마트스토어는 판매자 계정의 오늘출발 설정(마감시각·휴무일)을 따릅니다.<br/>
                  오늘출발 상품에는 위의 발송예정일(3일/4일)이 적용되지 않습니다.
                </div>
                </>
              )}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div><div style={sl}>예상구매가</div><input type="number" style={inp} value={form.expected_price} onChange={e => setForm(p=>({...p, expected_price: e.target.value}))} placeholder="0" /></div>
              <div><div style={sl}>재고수량</div><input type="number" style={inp} value={form.stock} onChange={e => setForm(p=>({...p, stock: e.target.value}))} placeholder="0" /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div><div style={sl}>브랜드</div><BrandSelector textValue={form.brand} catalogId={form.brand_id} onChangeText={v => setForm(p=>({...p, brand: v}))} onSelectCatalog={(id, name) => setForm(p=>({...p, brand_id: id, brand: name}))} /></div>
              <div><div style={sl}>제조사</div><ManufacturerSelector textValue={form.manufacturer} catalogId={form.manufacturer_id} onChangeText={v => setForm(p=>({...p, manufacturer: v}))} onSelectCatalog={(id, name) => setForm(p=>({...p, manufacturer_id: id, manufacturer: name}))} /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div><div style={sl}>원산지</div>
                <select style={inp} value={form.origin} onChange={e => setForm(p=>({...p, origin: e.target.value}))}>
                  <option>국산</option><option>수입산</option><option>기타</option>
                </select>
              </div>
              <div><div style={sl}>과세유무</div>
                <select style={inp} value={form.tax_type} onChange={e => setForm(p=>({...p, tax_type: e.target.value}))}>
                  <option>과세</option><option>비과세</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div><div style={sl}>총 내용량 (단위가격표시제 대상 카테고리인 경우 입력)</div>
                <input type="number" style={inp} value={form.total_capacity_value} onChange={e => setForm(p=>({...p, total_capacity_value: e.target.value}))} placeholder="예: 465 (155g x 3개)" />
              </div>
              <div><div style={sl}>개당 용량/중량 (쿠팡 등 구매옵션 필수 항목)</div>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <input type="number" style={{ ...inp, flex: 1 }} value={form.unit_capacity_value} onChange={e => setForm(p=>({...p, unit_capacity_value: e.target.value}))} placeholder="예: 155" />
                  <select style={{ ...inp, width: '90px' }} value={form.unit_capacity_type} onChange={e => setForm(p=>({...p, unit_capacity_type: e.target.value}))}>
                    <option value="">단위</option>
                    <option value="WEIGHT">중량(g)</option>
                    <option value="VOLUME">용량(ml)</option>
                  </select>
                </div>
              </div>
            </div>
            <div><div style={sl}>식품보관방법 (식품 카테고리인 경우 입력, 셀러허브 등에 필요)</div>
              <select style={inp} value={form.storage_method} onChange={e => setForm(p=>({...p, storage_method: e.target.value}))}>
                <option value="">선택 안 함</option>
                <option value="냉장">냉장</option>
                <option value="냉동">냉동</option>
                <option value="실온">실온</option>
              </select>
            </div>
            <div>
              <div style={sl}>생활화학/살생물제 인증 (세제/세정제 등 일부 카테고리만 해당)</div>
              {/* [기능 추가 - 2026-09-20] 스마트스토어 detailAttribute.certificationTargetExcludeContent
                  .chemicalCertifiedProductExclusionYn 매핑. 세제/세정제 등 일부 카테고리는 이 값이
                  없으면 등록이 거부된다(실전 확인: "생활화학/살생물제 인증대상 인증 종류를
                  선택하셔야 합니다"). "승인/신고대상"을 실제로 선택한 경우, 정확한 인증정보
                  (인증유형/기관/번호 등)는 이 시스템이 다루지 않으므로 스마트스토어 관리자
                  화면에서 직접 입력해야 한다. */}
              <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', cursor: 'pointer' }}>
                  <input type="radio" checked={form.chemical_certification_exempt === true}
                    onChange={() => setForm(p => ({ ...p, chemical_certification_exempt: true }))} />
                  승인/신고대상 아님
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '13px', cursor: 'pointer' }}>
                  <input type="radio" checked={form.chemical_certification_exempt === false}
                    onChange={() => setForm(p => ({ ...p, chemical_certification_exempt: false }))} />
                  승인/신고대상
                </label>
              </div>
              {form.chemical_certification_exempt === false && (
                <div style={{ fontSize: '11px', color: '#A32D2D', marginTop: '4px' }}>
                  ※ 인증유형/인증기관/인증번호 등 상세 정보는 등록 후 스마트스토어 관리자 화면에서 직접 입력해주세요.
                </div>
              )}
            </div>
            <div><div style={sl}>태그</div><input style={inp} value={form.tags} onChange={e => setForm(p=>({...p, tags: e.target.value}))} placeholder="예: 생수, 무라벨, 탄산" /></div>
            <div><div style={sl}>구매 사이트 URL</div><input style={inp} value={form.purchase_url} onChange={e => setForm(p=>({...p, purchase_url: e.target.value}))} placeholder="https://" /></div>
            <div><div style={sl}>가격비교 링크</div><input style={inp} value={form.price_compare_url} onChange={e => setForm(p=>({...p, price_compare_url: e.target.value}))} placeholder="https://" /></div>
          </div>
        </div>
        <div>
          <div style={{ fontSize: '12px', fontWeight: '600', color: '#444', marginBottom: '14px', paddingBottom: '6px', borderBottom: '0.5px solid #e8e8e8' }}>이미지 & 가격</div>
          <div style={{ marginBottom: '14px' }}>
            <div style={sl}>대표 이미지 (800x800 이상 권장)</div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <div style={{ width: '100px', height: '100px', border: '1px dashed #ddd', borderRadius: '8px', overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9f9f9' }}>
                {thumbnailPreview ? <img src={thumbnailPreview} alt="썸네일" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '10px', color: '#aaa' }}>미리보기</span>}
              </div>
              <label style={{ fontSize: '12px', padding: '6px 14px', borderRadius: '6px', border: '0.5px solid #1D9E75', background: '#E1F5EE', color: '#085041', cursor: 'pointer', marginTop: '4px' }}>
                이미지 선택<input type="file" accept="image/*" onChange={handleThumbnail} style={{ display: 'none' }} />
              </label>
            </div>
          </div>
          <div style={{ marginBottom: '14px' }}>
            <div style={{ fontSize: '12px', fontWeight: '600', color: '#444', marginBottom: '8px' }}>판매처별 실판매가</div>
            <div style={{ border: '0.5px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', borderBottom: '0.5px solid #f0f0f0', background: '#f9f9f9' }}>
                <span style={{ fontSize: '12px', width: '100px', color: '#444' }}>기본 (예상구매가)</span>
                <span style={{ fontSize: '12px', fontWeight: '500' }}>{parseInt(form.expected_price||0).toLocaleString()}원</span>
              </div>
              {PLATFORMS.map((p, i) => {
                const salePrice = calcPrices[p.code] || 0;
                const basePrice = parseInt(form.expected_price || 0);
                const feeRate = feeRates[p.code] || 0;
                const fee = Math.round(salePrice * feeRate);
                const margin = salePrice - basePrice - fee;
                const marginRate = salePrice > 0 ? (margin / salePrice * 100).toFixed(1) : 0;
                return (
                  <div key={p.code} style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', borderBottom: i < PLATFORMS.length-1 ? '0.5px solid #f0f0f0' : 'none', background: i%2===0?'#fff':'#fafafa' }}>
                    <span style={{ fontSize: '12px', width: '60px', color: '#444' }}>{p.name}</span>
                    <span style={{ fontSize: '12px', fontWeight: '500', color: '#1D9E75', width: '100px' }}>{salePrice ? salePrice.toLocaleString()+'원' : '-'}</span>
                    {salePrice > 0 && basePrice > 0 && (
                      <span style={{ fontSize: '11px', color: margin >= 0 ? '#185FA5' : '#E24B4A', marginLeft: '8px' }}>
                        {margin >= 0 ? '+' : ''}{margin.toLocaleString()}원 ({marginRate}%)
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ fontSize: '10px', color: '#aaa', marginTop: '6px', lineHeight: '1.6' }}>
              * 마진 = 판매가 - 예상구매가 - 수수료 (S: 6%, 나머지: 15%)<br/>
              * 참고용 수치이며 실제 마진과 다를 수 있습니다.
            </div>
          </div>
          <div><div style={sl}>상세페이지</div>
            <DetailPageEditor value={form.description} onChange={html => setForm(p=>({...p, description: html}))} />
          </div>
        </div>
      </div>
    </div>
  );
}

export { CategorySelector, DetailPageEditor, ProductForm };
